/* eslint-disable import/no-mutable-exports */
export const PUBLIC_CDN = 'https://public.hetaoimg.com';
export const IMG_CDN = 'https://img.hetao101.com';
export const SITE_CDN = 'https://oj.htcdn-a.com';
export let ENVIRONMENT = 'production';
export let OJ_API_BASE = 'https://api.htoj.com.cn';
export let HETAO_API_BASE = 'https://api.hetao101.com';
export let IM_API_BASE = 'https://im.hetao101.com';
export let PAGE_BASE = 'https://htoj.com.cn';

export function isProd() {
  return ENVIRONMENT === 'production';
}

export function getEnvString() {
  if (import.meta.dev) {
    // 本地开发
    return 'local';
  }

  const hostname = window.location.hostname;

  if (hostname.indexOf('hetaodev') >= 0) {
    // 核桃暂无提供开发环境
    // 之前赛事系统有提供开发环境
    return 'development';
  }

  if (hostname.indexOf('testing') >= 0) {
    // 核桃测试环境，可以支持多个测试环境
    // const d = location.hostname.split('.');
    // return d.find((i) => i.indexOf('testing') >= 0) as string;
    return 'testing';
  }

  return 'production';
}

function initEnvData4Hetao() {
  ENVIRONMENT = getEnvString();

  switch (ENVIRONMENT) {
    case 'local':
      // OJ_API_BASE = 'http://localhost:9000';
      // HETAO_API_BASE = 'http://localhost:9000';
      OJ_API_BASE = `https://api.testing.htoj.com.cn`;
      HETAO_API_BASE = `https://api.testing.hetao101.com`;
      IM_API_BASE = `https://im.testing.hetao101.com`;
      PAGE_BASE = `https://testing.htoj.com.cn`;
      break;
    case 'development':
      // 暂无开发环境
      OJ_API_BASE = 'https://api.hetaodev.htoj.com.cn';
      HETAO_API_BASE = 'https://api.hetaodev.hetao101.com';
      IM_API_BASE = 'https://im.hetaodev.hetao101.com';
      PAGE_BASE = `https://testing.htoj.com.cn`;
      break;
    case 'production':
      // 生产环境已经设置为默认值
      break;
    default:
      OJ_API_BASE = `https://api.${ENVIRONMENT}.htoj.com.cn`;
      HETAO_API_BASE = `https://api.${ENVIRONMENT}.hetao101.com`;
      IM_API_BASE = `https://im.${ENVIRONMENT}.hetao101.com`;
      PAGE_BASE = `https://${ENVIRONMENT}.htoj.com.cn`;
  }
}

function initEnvData4Saas() {
  ENVIRONMENT = getEnvString();

  switch (ENVIRONMENT) {
    case 'local':
      // OJ_API_BASE = 'http://localhost:9000';
      // HETAO_API_BASE = 'http://localhost:9000';
      OJ_API_BASE = `https://saas-api.testing.nutoj.com`;
      HETAO_API_BASE = `https://saas-api.testing.nutoj.com`;
      IM_API_BASE = `https://im.testing.hetao101.com`;
      PAGE_BASE = `https://testing.nutoj.com`;
      break;
    case 'development':
      // 暂无开发环境
      OJ_API_BASE = 'https://saas-api.hetaodev.nutoj.com';
      HETAO_API_BASE = 'https://saas-api.hetaodev.nutoj.com';
      IM_API_BASE = 'https://im.hetaodev.hetao101.com';
      PAGE_BASE = `https://testing.nutoj.com`;
      break;
    case 'production':
      // 生产环境
      OJ_API_BASE = `https://saas-api.nutoj.com`;
      HETAO_API_BASE = `https://saas-api.nutoj.com`;
      IM_API_BASE = `https://im.hetao101.com`;
      PAGE_BASE = `https://saas.nutoj.com`;
      break;
    default:
      OJ_API_BASE = `https://saas-api.${ENVIRONMENT}.nutoj.com`;
      HETAO_API_BASE = `https://saas-api.${ENVIRONMENT}.nutoj.com`;
      IM_API_BASE = `https://im.${ENVIRONMENT}.hetao101.com`;
      PAGE_BASE = `https://${ENVIRONMENT}.nutoj.com`;
  }
}

function initEnvData() {
  if (import.meta.env.VITE_SAAS_OJ === '1') {
    initEnvData4Saas();
  } else {
    initEnvData4Hetao();
  }
}

// 只会执行一次
initEnvData();
